import axios from "axios";

// export const API_BASE_URL = "http://127.0.0.1:8000/api";
export const API_BASE_URL = "https://admin.colorkingdon.in/api";

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "API-KEY": "REGISTANI#2025@ACHAR!KEY",
    },
});

// GET Request
export const getData = async (endpoint, params = {}) => {
    try {
        const response = await api.get(endpoint, { params });
        return response.data;
    } catch (error) {
        console.error("GET API Error:", error);
        throw error;
    }
};

// POST Request
export const postData = async (endpoint, data = {}) => {
    try {
        const response = await api.post(endpoint, data);
        return response.data;
    } catch (error) {
        console.error("POST API Error:", error);
        throw error;
    }
};

export const putData = async (endpoint, data = {}) => {
    try {
        const response = await api.put(endpoint, data);
        return response.data;
    } catch (error) {
        console.error("PUT API Error:", error);
        throw error;
    }
};

export const deleteData = async (endpoint) => {
    try {
        const response = await api.delete(endpoint);
        return response.data;
    } catch (error) {
        console.error("DELETE API Error:", error);
        throw error;
    }
};

export default api;